export { default } from './ActiveFilterLockSwitch.jsx';



// WEBPACK FOOTER //
// ./app/components/search/ActiveFilterLockSwitch/index.js